import type { AdminCityDto } from '@upme/contracts';
import { Badge } from '@upme/ui/components/badge';
import { useMemo } from 'react';

interface Props {
  cities: ReadonlyArray<AdminCityDto>;
  value: string[];
  onChange: (next: string[]) => void;
  disabled?: boolean;
}

/** Города роли бейджами. Неактивный город виден, только если уже выбран. */
export function CityMultiSelect({ cities, value, onChange, disabled = false }: Props) {
  const selected = useMemo(() => new Set(value), [value]);
  const visible = cities.filter((c) => c.isActive || selected.has(c.id));

  const toggle = (id: string) => {
    const next = new Set(selected);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    // Порядок — как в списке городов: стабильный набор для сравнения и для тела PATCH.
    onChange(visible.filter((c) => next.has(c.id)).map((c) => c.id));
  };

  return (
    <div className="flex flex-wrap gap-2">
      {visible.map((c) => {
        const on = selected.has(c.id);
        return (
          <button
            type="button"
            key={c.id}
            aria-pressed={on}
            disabled={disabled}
            onClick={() => toggle(c.id)}
            className="cursor-pointer rounded-md outline-hidden focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
          >
            <Badge variant={on ? 'default' : 'outline'}>{c.name}</Badge>
          </button>
        );
      })}
    </div>
  );
}
